import { EDITBTN } from "./ActionType";
import initialStatus from "./initialStatus";

const statusReducer = (state = initialStatus, action) => {
  switch (action.type) {
    case EDITBTN:
      return {
        ...state,
        status: !state.status,
        ids: action.payload,
      };
    default:
      return state;
  }
};
export default statusReducer;
